var _rect, _rect2, _rect3, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 419,
    viewBox: "0 0 200 419",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 170.977,
    y: 9.91888,
    width: 21,
    height: 202,
    rx: 10.5,
    transform: "rotate(20.0908 170.977 9.91888)",
    fill: "#0F0905"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 158.059,
    y: 19.0363,
    width: 39,
    height: 386,
    rx: 19.5,
    transform: "rotate(20.0908 158.059 19.0363)",
    fill: "#BB9457"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36.46,
    y: 395.153,
    width: 9,
    height: 16,
    rx: 4.5,
    transform: "rotate(20.0908 36.46 395.153)",
    fill: "#0F0905"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0381 400.807C35.632 399.735 37.6989 399.416 39.6405 400.126C41.582 400.836 42.955 402.414 43.4816 404.261L66.0232 383.323C55.5154 370.826 47.7884 367.773 30.3258 370.266L34.0381 400.807Z",
    fill: "#FFF9EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.431 62.1995C166.233 60.0984 166.801 56.1234 164.7 53.3211C162.599 50.5189 158.624 49.9505 155.822 52.0516L117.094 81.0898C117.094 81.0899 117.094 81.0899 117.094 81.0899L117.094 81.0899C117.094 81.0899 117.094 81.09 117.094 81.0899C117.094 81.0899 117.094 81.09 117.094 81.09L81.5353 178.307C80.4356 181.313 81.9815 184.642 84.9882 185.742C87.9949 186.842 91.3238 185.296 92.4236 182.289L122.038 101.324C124.698 94.0508 129.412 87.7065 135.608 83.0609L163.431 62.1995Z",
    fill: "#BB9457"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.02225bb371614b822e86ef25058e1667.svg";
export { ForwardRef as ReactComponent };